var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es290.js.map
